'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UICardSection = require('../card/UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _UIAccordionItem = require('../accordion/UIAccordionItem');

var _UIAccordionItem2 = _interopRequireDefault(_UIAccordionItem);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _AbstractTextElement = require('../elements/AbstractTextElement');

var _AbstractTextElement2 = _interopRequireDefault(_AbstractTextElement);

var _underscore = require('../utils/underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var legacySizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var titleSizes = ['extra-small', 'small', 'medium', 'large', 'extra-large'];
var headingForSize = {
  'extra-small': 'span',
  small: 'h5',
  medium: 'h4',
  large: 'h2',
  'extra-large': 'h1'
};

var isLegacyTitleSize = function isLegacyTitleSize(prop) {
  return legacySizes.indexOf(prop) >= 0;
};

exports.default = _react2.default.createClass({
  displayName: 'UICardHeader',

  propTypes: _extends({}, (0, _underscore.omit)(_UICardSection2.default.propTypes, ['children']), {
    className: _react.PropTypes.string,
    expanded: _react.PropTypes.bool.isRequired,
    onExpandChange: _react.PropTypes.func,
    title: _react.PropTypes.node,
    titleSize: _react.PropTypes.oneOf([].concat(legacySizes, titleSizes)),
    toolbar: _react.PropTypes.node
  }),

  getDefaultProps: function getDefaultProps() {
    return {
      expanded: true,
      titleSize: 'medium'
    };
  },
  renderToolbar: function renderToolbar(toolbar, expanded) {
    if (!toolbar || !expanded) return null;
    return _react2.default.createElement(
      'div',
      { className: 'private-card__toolbar' },
      toolbar
    );
  },
  renderTitle: function renderTitle(title, titleSize, isExpander, expanded, onExpandChange) {
    var isLegacy = isLegacyTitleSize(titleSize);

    if (isLegacy) {
      _devLogger2.default.warn({
        message: 'UICardHeader: the `titleSize` prop now takes t-shirt sizes ' + ' (`small`, `medium`, `large`) instead of `h1`-`h6`',
        key: 'UIAccordionItem: use size prop'
      });
    }

    if (isExpander === true) {
      return _react2.default.createElement(_UIAccordionItem2.default, {
        className: 'private-card__title',
        onOpenChange: onExpandChange,
        open: expanded,
        title: title,
        size: isLegacy ? undefined : titleSize,
        textElement: isLegacy ? titleSize : undefined
      });
    }

    return _react2.default.createElement(
      _AbstractTextElement2.default,
      {
        className: 'private-card__title',
        tagName: isLegacy ? titleSize : headingForSize[titleSize]
      },
      title
    );
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        expanded = _props.expanded,
        onExpandChange = _props.onExpandChange,
        title = _props.title,
        titleSize = _props.titleSize,
        toolbar = _props.toolbar,
        other = _objectWithoutProperties(_props, ['className', 'expanded', 'onExpandChange', 'title', 'titleSize', 'toolbar']);

    var isExpander = typeof onExpandChange === 'function';

    var classes = (0, _reactUtils.classNames)('private-card__header', className, {
      'private-card__header--with-toolbar': !!toolbar,
      'private-card__header--expandable': isExpander === true
    });

    return _react2.default.createElement(
      _UICardSection2.default,
      _extends({ className: classes }, other),
      _react2.default.createElement(
        _UIFlex2.default,
        { align: 'start', justify: 'between' },
        this.renderTitle(title, titleSize, isExpander, expanded, onExpandChange),
        this.renderToolbar(toolbar, expanded)
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/card/UICardHeader.js
// module id = 357
// module chunks = 0